import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import EditSlotComp from "./Component/EditSlotComp"


const EditSlot =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditSlotComp />
        </div>
        <Footer />
        </>
    )
}

export default EditSlot;